import isMobile from "is-mobile";
import { Page } from "..";
import { UserInfoHeader } from "../../../modules/profile-dashboard/components/user-info-header";
import {
  LogoImg,
  ProfileContainer,
  TopContainer,
  TopMenuContainter,
} from "./styles";
import gph from "../../../assets/images/logo-georanking.png";

export const HeaderAux: React.FC = () => {
  return (
    <>
      <TopContainer>
        {isMobile() ? (
          <TopMenuContainter>
            <Page.NavBar /> <LogoImg src={gph} />
          </TopMenuContainter>
        ) : (
          <LogoImg src={gph} />
        )}
        <ProfileContainer>
          <UserInfoHeader balance={0} userName="" userRole="Gestor de Contas" />
        </ProfileContainer>
      </TopContainer>
      {!isMobile() && <Page.NavBar />}
    </>
  );
};
